module.exports = __webpack_public_path__ + "static/img/celoscope-12.9f6d3cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-12.jpg
// module id = BVY0
// module chunks = 51